import { DialogService } from "@/service/DialogService"
import { YuukyuuKanriService } from "@/service/YuukyuuKanriService"
import { YuukyuuShinseiData } from "@/types/YuukyuuKanri"
import { computed, ref } from "vue"

/*
 * 有給休暇取得一覧
 */
export function useList() {
  let loading = ref(0)
  let isError = ref(false)
  const service = new YuukyuuKanriService()

  // 読み込み中か判断する
  const isListLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  })

  // 指定期間の有給休暇一覧を取得する
  const getKyukaList = async (
    userId: number, 
    start: string | null, 
    end: string | null, 
    konnenFuyoDays: number | null, 
    kurikoshiDays: number | null, 
    tokubetsuKyuuka: number | null,
  ) => {
    loading.value++
    const res = await service.getYuukyuuShinseiList(userId, start, end, konnenFuyoDays, kurikoshiDays, tokubetsuKyuuka)
    loading.value--
    return res.list
  }

  // 有給取消を行う
  const deleteYuukyuu = async (
    shinseiData: YuukyuuShinseiData
  ) => {
    loading.value++
    DialogService.nowloading('処理中...');
    const res = await service.deleteYuukyuu(shinseiData)
    if(res){
      DialogService.info({text: `有給を取り消しました`}, true);
    }
    loading.value--
    return res
  }

  return {
    getKyukaList,
    isListLoading,
    isError,
    deleteYuukyuu,
  }
}

